import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';

const SidebarLink = styled(Link)`
  display: flex;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  height: 50px;
  text-decoration: none;
  font-size: 1.375rem;
  margin-bottom: 1.8rem;
  margin-top: 1.8rem;
 
  &:hover {
    cursor: pointer;
    color: #fff;
    font-weight: bold;
  }

  &.active {
       background: rgba(0, 0, 0, 0.2);
  }
`;

const SidebarLabel = styled.span`
  font-size: medium;
`;

const DropdownLink = styled(Link)`
  height: auto;
  padding-left: 3.5rem !important;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-size: 0.838rem !important;
  position: relative;
  transition: all 0.3s ease;
  padding: 8px 0;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  opacity: 0.6;
  border-radius: 0 8px 8px 0;
 
  &:hover {
    cursor: pointer;
    color: #fff;
    padding-left: 3.5rem !important;
    opacity: 0.9;
  }

  &.sub_active {
    font-weight: bold;
    opacity: 1;
    position: relative;
    padding-left: 3.5rem !important;
    color: #fff;
  }
 
`;
 
const Menu = ({ item }) => {
  const location = useLocation();
  const [subnav, setSubnav] = useState(item.subNav ? true : false);
  const showSubnav = () => {
    setSubnav(!subnav);
  };

  return (
    <>
    
      <SidebarLink to={item.path} 
      onClick={item.subNav && showSubnav} className={showSubnav && location.pathname === item.path ? 'active' : ''}>
        <div>
          <img src={item.icon}></img>
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </SidebarLink>
      {subnav &&
        item.subNav.map((subItem, index) => {
          return (
            <DropdownLink
              to={subItem.path}
              key={index}
              className={location.pathname === subItem.linkpath ? 'sub_active' : ''}
            >
              <SidebarLabel>{subItem.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};
 
export default Menu;